// extracted by mini-css-extract-plugin
module.exports = {"mcat-navigation":"Navigation_mcat-navigation__2NFm8","menu":"Navigation_menu__16zNQ"};